function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-list-ext_svg__clip0)",
  fill: "#879097"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.6 16H7.4c-.773 0-1.4.896-1.4 2s.627 2 1.4 2h11.2c.773 0 1.4-.896 1.4-2s-.627-2-1.4-2zM18.6 8H7.4C6.627 8 6 8.895 6 10s.627 2 1.4 2h11.2c.773 0 1.4-.895 1.4-2 0-1.104-.627-2-1.4-2zM2.297 3.965h15.666c1.081 0 1.958-.893 1.958-1.995 0-1.101-.877-1.994-1.958-1.994H2.297C1.216-.024.34.87.34 1.97c0 1.102.877 1.995 1.958 1.995z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-list-ext_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));

function SvgIconListExt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconListExt;